export class BackgroundRemovalModel {
  image : File | null=null;
}

export class BackgroundRemovalResponseModel {
  base64_image!:string;
  content_type!:string;
}
